export default {
  primary: "#A675A1",
  secondary: "#B8E1FF",
};
